import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

export const AppThemePreset = definePreset(Aura, {
	semantic: {
		primary: {
			50: '{teal.50}',
			100: '{teal.100}',
			200: '{teal.200}',
			300: '{teal.300}',
			400: '{teal.400}',
			500: '{teal.500}',
			600: '{teal.600}',
			700: '{teal.700}',
			800: '{teal.800}',
			900: '{teal.900}',
			950: '{teal.950}',
		},
		secondary: {
			50: '{cyan.50}',
			100: '{cyan.100}',
			200: '{cyan.200}',
			300: '{cyan.300}',
			400: '{cyan.400}',
			500: '{cyan.500}',
			600: '{cyan.600}',
			700: '{cyan.700}',
			800: '{cyan.800}',
			900: '{cyan.900}',
			950: '{cyan.950}',
		},

		colorScheme: {
			light: {
				semantic: {
					highlight: {
						background: '{primary.50}',
						color: '{primary.700}',
					},
				},
				formField: {
					hoverBorderColor: '{primary.color}',
					color: '{surface.900}',
				},
			},
		},
	},
});
